import { render, staticRenderFns } from "./publicTitle.vue?vue&type=template&id=070e683d&scoped=true&"
import script from "./publicTitle.vue?vue&type=script&lang=js&"
export * from "./publicTitle.vue?vue&type=script&lang=js&"
import style0 from "./publicTitle.vue?vue&type=style&index=0&id=070e683d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e683d",
  null
  
)

export default component.exports